const SATURATION = 75;
const LIGHTNESS = 45;

const generateColorFromString = (
  str: string,
  saturation: number = SATURATION,
  lightness: number = LIGHTNESS
): string => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  // Convert hash to hue and keep it within [0-360) range as it is an angle
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

export default generateColorFromString;
